import React from 'react';
import { ClearableError } from './shared';
import { ErrorContent } from '../ErrorContent';
import { pushErrorEventToDataLayer } from '../../analytics/pushErrorEventToDataLayer';

interface ErrorBoundaryRudeProps {}

interface ErrorBoundaryRudeState {
  error: ClearableError;
}

/**
 * ErrorBoundaryRude shows an entire error page and should be reserved for when an
 * error is not recoverable.
 */
export class ErrorBoundaryRude extends React.Component<
  ErrorBoundaryRudeProps,
  ErrorBoundaryRudeState
> {
  constructor(props: any) {
    super(props);
    this.state = {
      error: null
    };
  }

  static getDerivedStateFromError(error: Error) {
    return { error };
  }

  componentDidCatch(error: Error) {
    pushErrorEventToDataLayer({
      error_type: 'unknown_error',
      error_category: 'unknown_error_category',
      error_code: 'REACT_ERROR_BOUNDARY_RUDE',
      error_description: `React render error caught by rude boundary: ${error.message ||
        'Something went wrong'}.`,
      error_location: 'ErrorBoundaryRude.componentDidCatch',
      error_object: error
    });
  }

  render() {
    const { children } = this.props;
    const { error } = this.state;
    if (error) {
      return <ErrorContent msg={error?.message} />;
    }
    return children;
  }
}
